import React, { Component } from 'react';
import { Col, } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import DataReactTable from './DataReactTable';
import TableActions from './TableActions';
import Spinner from 'react-bootstrap/Spinner';

class SourceDocuments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            documents: [],
            isLoading: true,
        };
    }

    componentDidMount() {
        this.getDataFiles();
    }

    getDataFiles = () => {

        let dataSend = {
            id_historia: parseInt(this.props.id_historia),
            id_admision: 0
        };

        console.log(dataSend);
        fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                //console.log(data);

                this.createDatateble(data.contenido);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    createDatateble = (data) => {

        let filterData = [];

        for (let i = 0; i < data.length; i++) {

            if (data[i].archivos !== null) {

                for (let j = 0; j < data[i].archivos.archivos.length; j++) {

                    filterData.push(data[i].archivos.archivos[j]);
                }
            }
        }

        this.setData(filterData);
    }

    setData = (data) => {

        let filterData = [];

        for (let i = 0; i < data.length; i++) {
            filterData[i] = {

                clase: data[i].clase === "1" ? "CONSENTIMIENTO INFORMADO" :
                    data[i].clase === "2" ? "ECOCARDIOGRAMA MODO M" :
                        data[i].clase === "3" ? "ECOCARDIOGRAMA STRESS" :
                            data[i].clase === "4" ? "ELECTROCARDIOGRAMAS" :
                                data[i].clase === "5" ? "FORMULA MEDICA" :
                                    data[i].clase === "6" ? "HISTORIA CLINICA" :
                                        data[i].clase === "7" ? "HOLTER CARDIACO" :
                                            data[i].clase === "8" ? "IMAGENOLOGIA" :
                                                data[i].clase === "9" ? "LABORATORIO CLINICO" :
                                                    data[i].clase === "10" ? "MONITOREO DE PRESION ARTERIAL" :
                                                        data[i].clase === "11" ? "ORDEN MEDICA" :
                                                        data[i].clase === "12" ? "GAMAGRAFIAS" : 
                                                        data[i].clase === "13" ? "RESONANCIA NUCLERA MAGNETICA" : 
                                                        data[i].clase === "14" ? "DOCUMENTO DE IDENTIDAD" :
                                                        data[i].clase === "15" ? "AUTORIZACION" :
                                                        data[i].clase === "16" ? "OTROS" :
                                                        "",
                fecha: data[i].fecha,
                hora: data[i].hora,
                nombre: data[i].fileName,
                usuario: typeof data[i].usuario !== 'undefined' ? data[i].usuario : "",
                descripcion: data[i].descripcion,
                ruta: data[i].ruta

            }
        }

        //console.log(filterData);
        this.setState({ documents: filterData, isLoading: false });

    }

    render() {

        const reactTableData = {
            tableHeaderData: [
                {
                    Header: 'Clase documento',
                    accessor: 'clase',
                    disableGlobalFilter: true,
                    width: 65,
                },
                {
                    Header: 'Fecha',
                    accessor: 'fecha',
                },
                {
                    Header: 'Hora',
                    accessor: 'hora',
                },
                {
                    Header: 'Nombre',
                    accessor: 'nombre',
                },
                {
                    Header: 'Descripción',
                    accessor: 'descripcion',
                },
            ],
            tableRowsData: this.state.documents
        };

        return (<Col>
            <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
                <div className="card__title">
                    <h5 className="bold-text">Documentos cargados</h5>
                </div>
                <div>
                    {this.state.documents.length < 1 ? (
                        <h5 className="bold-text">El paciente no tiene documentos cargados</h5>
                    ) :
                        this.state.isLoading ? (<Spinner animation="border" variant="success" />)
                            : <DataReactTable title={'Documentos Cargados'} reactTableData={reactTableData} ReactTableActions={TableActions} />
                    }
                </div>
            </div>
        </Col>);
    }
}

export default reduxForm({
    form: `source-docs-form`, // a unique identifier for this form
})(withTranslation('common')(SourceDocuments));